// extracted by mini-css-extract-plugin
export var container = "styles-module--container--sv88S";
export var layerBook = "styles-module--layerBook--j4dKr";
export var clickToWrite = "styles-module--clickToWrite--RCKJx";
export var layerPaper = "styles-module--layerPaper--9mZDU";
export var hide = "styles-module--hide--VAOBX";
export var layerPen = "styles-module--layerPen--xXbrF";
export var close = "styles-module--close--23CLt";
export var pen = "styles-module--pen--Tydbp";